module.exports = __webpack_public_path__ + "media/images/landing/home/banner_landing-33230cd35e7724172bc15006a233d3a4.png";